export const HTTP_METHOD = {
    GET: "GET",
    POST: "POST",
    PUT: "PUT",
    DELETE: "DELETE",
};

export const API_STATUS = {
    PENDING: "API_PENDING",
    SUCCESS: "API_SUCCESS",
    ERROR: "API_ERROR",
};